import { REDUX_ACTIONS } from "constants/constants";

const initialState = {
  cUID: null, //cart unique identifier
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.CREATE_CART_UNIQUE_ID:
      return { cUID: action.payload };

    case REDUX_ACTIONS.RESET_CART_UNIQUE_ID:
      return initialState;
    default:
      return state;
  }
};

export default cartReducer;
